module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n4r8n7n-8ffd4554f943db9d2dc7bdcf9fe0b700.svg";